<label class="d-block checkbox">
	<input type="checkbox" (click)="onClick()" (blur)="onBlur()" [checked]="checked" />
	<span class=""
		>{{ text }} <span class="front-main-1 font-bold" routerLinkActive="router-link-active"> {{ textSpan }}</span></span
	>
</label>
